module.exports = __webpack_public_path__ + "static/media/damaha_da.0badf87d.ogg";